var React = require('react');

function MapOptions (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5Z","stroke":"#3D5265","key":0}),React.createElement("path",{"d":"M16 23.3336L9 17.8947L10.0484 17.0896L16 21.6971L21.9516 17.0896L23 17.8947L16 23.3336ZM16 19.5445L9 14.1056L16 8.6665L23 14.1056L16 19.5445Z","fill":"#3D5265","key":1})]);
}

MapOptions.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = MapOptions;

MapOptions.default = MapOptions;
